import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function Login() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  
  const [loginEmail, setLoginEmail] = useState('');
  const [loginPassword, setLoginPassword] = useState('');
  
  const [registerName, setRegisterName] = useState('');
  const [registerEmail, setRegisterEmail] = useState('');
  const [registerPassword, setRegisterPassword] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      const response = await axios.post(`${API}/auth/login`, {
        email: loginEmail,
        password: loginPassword,
      });
      
      localStorage.setItem('token', response.data.access_token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      
      toast.success(`Bem-vindo, ${response.data.user.name}!`);
      
      if (response.data.user.role === 'admin') {
        navigate('/admin');
      } else {
        navigate('/portal');
      }
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erro ao fazer login');
    } finally {
      setLoading(false);
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      const response = await axios.post(`${API}/auth/register`, {
        name: registerName,
        email: registerEmail,
        password: registerPassword,
      });
      
      localStorage.setItem('token', response.data.access_token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      
      toast.success('Conta criada com sucesso!');
      navigate('/portal');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erro ao registar');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8">
          <img 
            src="/logo-dih.png" 
            alt="Do IT Happen" 
            className="h-16"
          />
        </div>

        <Card className="bg-slate-900 border-slate-800 shadow-2xl">
          <CardHeader>
            <CardTitle className="font-['Manrope'] text-2xl text-center text-white">
              Traducao AI
            </CardTitle>
            <p className="font-['Inter'] text-sm text-slate-400 text-center">
              Sistema de Traducao Simultanea
            </p>
          </CardHeader>
          <CardContent>
            <Tabs defaultValue="login" className="w-full">
              <TabsList className="grid w-full grid-cols-2 mb-6 bg-slate-800">
                <TabsTrigger value="login" className="data-[state=active]:bg-slate-700 data-[state=active]:text-white text-slate-400">Login</TabsTrigger>
                <TabsTrigger value="register" className="data-[state=active]:bg-slate-700 data-[state=active]:text-white text-slate-400">Registar</TabsTrigger>
              </TabsList>
              
              <TabsContent value="login">
                <form onSubmit={handleLogin} className="space-y-4">
                  <div>
                    <label className="font-['Inter'] text-sm font-medium mb-2 block text-slate-300">
                      Email
                    </label>
                    <Input
                      type="email"
                      placeholder="admin@traducaoai.com"
                      value={loginEmail}
                      onChange={(e) => setLoginEmail(e.target.value)}
                      required
                      className="bg-slate-800 border-slate-700 text-white placeholder:text-slate-500"
                      data-testid="login-email-input"
                    />
                  </div>
                  
                  <div>
                    <label className="font-['Inter'] text-sm font-medium mb-2 block text-slate-300">
                      Password
                    </label>
                    <Input
                      type="password"
                      placeholder="••••••••"
                      value={loginPassword}
                      onChange={(e) => setLoginPassword(e.target.value)}
                      required
                      className="bg-slate-800 border-slate-700 text-white placeholder:text-slate-500"
                      data-testid="login-password-input"
                    />
                  </div>
                  
                  <Button
                    type="submit"
                    className="w-full bg-blue-600 hover:bg-blue-700"
                    disabled={loading}
                    data-testid="login-submit-btn"
                  >
                    {loading ? 'A entrar...' : 'Entrar'}
                  </Button>
                </form>
              </TabsContent>
              
              <TabsContent value="register">
                <form onSubmit={handleRegister} className="space-y-4">
                  <div>
                    <label className="font-['Inter'] text-sm font-medium mb-2 block text-slate-300">
                      Nome
                    </label>
                    <Input
                      type="text"
                      placeholder="Seu nome"
                      value={registerName}
                      onChange={(e) => setRegisterName(e.target.value)}
                      required
                      className="bg-slate-800 border-slate-700 text-white placeholder:text-slate-500"
                      data-testid="register-name-input"
                    />
                  </div>
                  
                  <div>
                    <label className="font-['Inter'] text-sm font-medium mb-2 block text-slate-300">
                      Email
                    </label>
                    <Input
                      type="email"
                      placeholder="seu@email.com"
                      value={registerEmail}
                      onChange={(e) => setRegisterEmail(e.target.value)}
                      required
                      className="bg-slate-800 border-slate-700 text-white placeholder:text-slate-500"
                      data-testid="register-email-input"
                    />
                  </div>
                  
                  <div>
                    <label className="font-['Inter'] text-sm font-medium mb-2 block text-slate-300">
                      Password
                    </label>
                    <Input
                      type="password"
                      placeholder="Minimo 6 caracteres"
                      value={registerPassword}
                      onChange={(e) => setRegisterPassword(e.target.value)}
                      required
                      minLength={6}
                      className="bg-slate-800 border-slate-700 text-white placeholder:text-slate-500"
                      data-testid="register-password-input"
                    />
                  </div>
                  
                  <Button
                    type="submit"
                    className="w-full bg-green-600 hover:bg-green-700"
                    disabled={loading}
                    data-testid="register-submit-btn"
                  >
                    {loading ? 'A criar conta...' : 'Criar Conta'}
                  </Button>
                </form>
              </TabsContent>
            </Tabs>

            <div className="mt-6 text-center">
              <Button
                variant="ghost"
                onClick={() => navigate('/')}
                className="text-sm text-slate-400 hover:text-white"
                data-testid="back-to-home-btn"
              >
                Voltar ao Inicio
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
